import type { PageConfig } from '#shared/types/page-config'
import { relative } from '~/utils/path'

export const usePageConfig = async (): Promise<PageConfig> => {
  const { environment, host, path, headers } = usePageEnvironment()
  const data = await useAsyncData('page-config', () => {
    const config = getPageConfig(environment, host, path, headers)

    if (config === undefined) {
      throw new Error(`No page config matched the current request. Environment: ${environment}; Host: ${host}; Path: ${path}; Headers: ${Object.keys(headers).join(', ')}`)
    }

    return Promise.resolve(config)
  })
  if (data.error.value) {
    throw data.error.value
  }
  const config = data.data.value!

  return {
    relativePath: config.path ? join('/', relative(config.path, path)) : path,
    etUrl: config.etUrl,
    storyblok: {
      ...config.storyblok,
    },
    errorPage: config.errorPage,
  }
}
